var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dive"},[_c('div',{staticClass:"dive__text subtitle--small"},[_c('span',{ref:"text",staticClass:"ff-dr ft-16"},[_vm._v("DIVE DEEPER")])]),_c('span',{ref:"line",staticClass:"dive__line"})])}
var staticRenderFns = []

export { render, staticRenderFns }